import React from "react";

function makeIcon(paths) {
  return function Icon({ size = 24, className = "", ...props }) {
    return (
      <svg className={className} width={size} height={size} viewBox="0 0 24 24" fill="none"
        stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"
        aria-hidden={props["aria-label"] ? undefined : "true"} {...props}>
        {paths.map((path, index) => <path key={index} d={path} />)}
      </svg>
    );
  };
}

export const Archive = makeIcon(["M4 7h16", "M5 7l1 13h12l1-13", "M9 11h6", "M8 4h8l1 3H7z"]);
export const ArrowLeftRight = makeIcon(["M7 7h13", "M16 3l4 4-4 4", "M17 17H4", "M8 13l-4 4 4 4"]);
export const Boxes = makeIcon(["M4 4h7v7H4z", "M13 4h7v7h-7z", "M4 13h7v7H4z", "M13 13h7v7h-7z"]);
export const Check = makeIcon(["M5 12l4 4L19 6"]);
export const ChevronRight = makeIcon(["M9 5l7 7-7 7"]);
export const CirclePlus = makeIcon(["M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18", "M12 8v8", "M8 12h8"]);
export const CreditCard = makeIcon(["M3 6h18v12H3z", "M3 10h18", "M7 15h3"]);
export const Eye = makeIcon(["M2 12s4-6 10-6 10 6 10 6-4 6-10 6S2 12 2 12", "M12 9a3 3 0 1 0 0 6 3 3 0 0 0 0-6"]);
export const EyeOff = makeIcon(["M3 3l18 18", "M10.5 6.2A10.7 10.7 0 0 1 12 6c6 0 10 6 10 6a16 16 0 0 1-2.2 2.8", "M6.2 6.2C3.6 8.1 2 12 2 12s4 6 10 6c1.2 0 2.3-.2 3.3-.6"]);
export const Image = makeIcon(["M4 4h16v16H4z", "M7 16l4-4 3 3 2-2 3 3", "M9 9h.01"]);
export const LayoutDashboard = makeIcon(["M4 4h7v10H4z", "M13 4h7v6h-7z", "M13 12h7v8h-7z", "M4 16h7v4H4z"]);
export const LoaderCircle = makeIcon(["M21 12a9 9 0 1 1-2.6-6.4"]);
export const Package = makeIcon(["M4 7l8-4 8 4v10l-8 4-8-4z", "M4 7l8 4 8-4", "M12 11v10"]);
export const Pencil = makeIcon(["M4 20l4.5-1 10-10-3.5-3.5-10 10z", "M14 6l3.5 3.5"]);
export const Plus = makeIcon(["M12 5v14", "M5 12h14"]);
export const RefreshCw = makeIcon(["M20 7v5h-5", "M4 17v-5h5", "M6.1 8a7 7 0 0 1 11.7-2L20 12", "M4 12l2.2 6a7 7 0 0 0 11.7-2"]);
export const Search = makeIcon(["M11 4a7 7 0 1 0 0 14 7 7 0 0 0 0-14", "M16 16l5 5"]);
export const Settings2 = makeIcon(["M4 7h10", "M18 7h2", "M14 5v4", "M4 17h2", "M10 17h10", "M8 15v4"]);
export const ShoppingBag = makeIcon(["M5 8h14l-1 12H6z", "M9 8a3 3 0 0 1 6 0"]);
export const Trash2 = makeIcon(["M4 7h16", "M9 7V4h6v3", "M7 7l1 13h8l1-13", "M10 11v5", "M14 11v5"]);
export const Upload = makeIcon(["M12 16V4", "M7 9l5-5 5 5", "M5 20h14"]);
export const X = makeIcon(["M6 6l12 12", "M18 6L6 18"]);
